module.exports = __webpack_public_path__ + "img/help-head.4071c377.png";